import { Fragment, useRef, useState } from "react"
import { Button, Card, Col, Modal, Row, Spinner } from "react-bootstrap"
import { useSelector } from "react-redux"
import ModalAtualizarUsuarios from "../../modal/ModalAtualizarUsuarios"

import './BodyRow.scss'
import { valorMoeda, locationDev, correctDataUTC, deleteData } from "../../../services/Servicos"
import ModalFoto from "../../modal/ModalFoto"
import BotaoSalvar from "../../botoes/BotaoSalvar"
import { getErrorMessage } from "../../../services/helpers"
import ModalErrorPretty from "../../modal/ModalErrorPretty"

export default function BodyRowAbastecimento({ headList, bodyList, index, setEditarAbastecimento = () => {}, tableLength, restartData}) {

   const refRow = useRef(null)
    const refEditar = useRef(null)
    const user = useSelector(state => state.userSlice)
    const filiaisList = user.filiaisList.data 
    const [loading, setLoading] = useState(false)

    const [adminFunction, setAdminFunction] = useState({
        flag: false,
        imgSrc: '',
        alternativo: ''
    })

    const [showExclusao, setShowExclusao] = useState({
        show: false
    })

    const onClickEditarRow = (e) => {
        setEditarAbastecimento({
            flag: true,
            body: bodyList,
            title: 'Editar Abastecimento N°' + bodyList.id,
        })
    }

    const onClickTableRow = (e) => {
        e.preventDefault()
        refRow.current.classList = 'bg-selected'
        let refRowNumber = index

        let i = refRowNumber
        let actualSibling = refRow.current.nextSibling

        while(i < tableLength){
            if(actualSibling === null){
                break
            }
            actualSibling.classList = ''
            
            actualSibling = actualSibling.nextSibling
            i++
        }

        i =  index
        actualSibling = refRow.current.previousSibling
        while(0 < i ){
            if(actualSibling === null){
                break
            }
            actualSibling.classList = ''
            actualSibling = actualSibling.previousSibling
            i--
        }     
        
        
    }

    const onClickExcluir = () => {
        setShowExclusao({show: true, bodyList})
    }


    return (
        <Fragment>
            {
                <tr ref={refRow}  onClick={onClickTableRow}>
                    {
                        headList.map((item, _index) => {

                            if (item === 'index') {
                                return <td key={_index}> {index + 1}</td>

                            }
                            else if (item === 'suporte') {

                                return <td key={_index}>
                                    <div className="admin align-items-center">
                                        <span className="editar"><i className="bi bi-gear" title="Editar" onClick={onClickEditarRow} ref={refEditar}></i></span>
                                        <span className="editar"><i className="bi bi-x-lg" title="Excluir Lançamento" onClick={onClickExcluir}></i></span>
                                    </div>
                                </td>
                            }
                                
                            else if (item === 'admin') {

                                return <td key={_index}>
                                    {
                                        (!bodyList.cargas_id || !bodyList.cargas_id_chegada) && bodyList.tipo_maquina == 'CAMINHAO' && bodyList.tipo_lancamento == 'LANÇAMENTO PADRÃO'? 
                                            <div className="admin">
                                                <span className="editar"><i className="bi bi-gear" title="Editar" onClick={onClickEditarRow} ref={refEditar}></i></span>
                                            </div>
                                            :
                                            <div className="admin">
                                                <span className="editar"><i className="bi bi-bookmark-check-fill" title="Editar" style={{color:"#04c704c7"}}></i></span>
                                            </div>
                                    }
                                </td>
                            } else if (item === 'id') { /* primary key can not be modified */

                                return <td key={_index}>{bodyList[item]}</td>

                            } else if (item === 'placa') { /* primary key can not be modified */

                                return <td key={_index}>{bodyList[item]}</td>

                            } 
                            else if (item === 'status') {

                                return bodyList[item] ?
                                    <td key={_index} className={item}>
                                        <div className="div-status">
                                            <span className="div-status-ativo">Ativo</span>
                                        </div>
                                    </td> : <td key={_index} className={item}>
                                        <div className="div-status">
                                            <span className="div-status-inativo">Inativo</span>
                                        </div>
                                    </td>

                            } 
                            else if (item.includes('valor')) { /* primary key can not be modified */

                                return <td key={_index} style={{minWidth:'10rem'}}>{valorMoeda(bodyList[item])}</td>

                            }
                            else if (item === 'data') { /* primary key can not be modified */

                                return <td key={_index} style={{minWidth:'10rem'}}>{bodyList[item]}</td>

                            }
                            else if (item === 'horimetro' || item === 'foto_bomba_combustivel') { /* primary key can not be modified */
							const altText = item === 'horimetro' ? 'Foto do Horimetro' : 'Foto da Bomba de Combustivel'
                            const imgSrc = `${locationDev}/files/users/abastecimentos/${bodyList.caminhao}/${bodyList[item]}`

                                if (!bodyList[item]) {
                                    return (
                                        <td key={_index} className='abastecimento-media-cell'>
                                            <div className='abastecimento-media-placeholder'>NÃO INFORMADO</div>
                                        </td>
                                    )
                                }

                                return <td key={_index} >
                                    <Card.Img
                                        variant='top'
                                        src={imgSrc}
                                        alt={altText}
                                        height={100}
                                        width={100}
                                        className='abastecimento-thumbnail'
                                        onClick={e => setAdminFunction({flag: true, imgSrc, alternativo: altText})}
                                    />
                                </td>

                            }
                            else if (item === 'litros_abastecidos' || item === 'ultimo_km') { /* primary key can not be modified */

                                return <td key={_index} className={item}> {Number(bodyList[item]).toLocaleString('pt-br')}</td>

                            }
                            else if (item === 'emissao') { /* primary key can not be modified */

                                return <td key={_index} className={item}> {correctDataUTC(bodyList.emissao)}</td>

                            }
                            else if (item === 'id_filial') {
                                return <td key={_index}>{filiaisList.filter(item => item.idFilial == bodyList.id_filial)[0]?.identificacaoInterna ?? 'NÃO INFORMADO'}</td>
                            } 
                            return <td key={_index} className={item}> {bodyList[item]}</td>
                        })
                    }
                </tr>
            }
            {
                adminFunction.flag ? 
                    <ModalFoto 
                        imgSrc={adminFunction.imgSrc}  
                        setShow={setAdminFunction} 
                        show={adminFunction.flag} 
                        alternativo={adminFunction.alternativo}
                        />
                    : ""
            }
            {showExclusao.show ? (
                <ModalConfirmarExclusao setShow={setShowExclusao} {...showExclusao} fnRetorno={restartData}/>
            ) : (
                ""
            )}
        </Fragment>
    )
}

function ModalConfirmarExclusao({ show, setShow, bodyList, fnRetorno }) {
    
    const handlerSimpleClose = () => setShow(last => ({ ...last, show: false }))
    const [btnConfirmar, setBtnConfirmar] = useState({
        style: "primary",
        msg: "Excluir",
    });
    const [error, setError] = useState({
        show: false,
    });	
        
    const onClickExcluir = async (e) => {
        
		setBtnConfirmar({ msg: "Excluindo", style: "warning" });
        try {
            await deleteData(`abastecimentos/${bodyList.id}`)
            setBtnConfirmar({ msg: "Excluido", style: "success" });
            setTimeout(() =>{
                handlerSimpleClose()
            },500)
        } catch (error) {
            setError({show: true, message: getErrorMessage(error)})
        }
    }
    return (
        <>
            <Modal
                show={show}
                onHide={handlerSimpleClose}
                backdrop='static'
                keyboard={false}
                centered
                size='sm'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Exclusão?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center mb-3">
                        <div
                            style={{
                                width: "100px",
                                height: "100px",
                                background: "red",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <i
                                className="bi bi-exclamation-circle text-white"
                                style={{ fontSize: "4rem" }}
                            ></i>
                        </div>
                    </div>
                    <h5 style={{textAlign:"center"}}>
                        Deseja confirmar a exclusão do abastecimento {bodyList.id} ?
                    </h5>
                </Modal.Body>
                <Modal.Footer className="d-block">
                    <Row>
                        <Col sm='6' className="p-0">
                            <BotaoSalvar
                                style={btnConfirmar.style}
                                msg={btnConfirmar.msg}
                                fnRetorno={onClickExcluir}
                            />
                        </Col>
                        <Col sm='6' className="p-0">
                            <Button variant='secondary' onClick={handlerSimpleClose}>Sair</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
            {error.show ? (
                <ModalErrorPretty setShow={setError} {...error} />
            ) : (
                ""
            )}
        </>
    )
}